export const NEWS_NAV = { it: "News", en: "News" };

export const newsCopy = {
  it: {
    kicker: "News & Blog",
    titleA: "Idee, strategie",
    titleB: "e nuovi progetti.",
    intro: "Articoli, comunicati e novità dal mondo RV Film: video marketing, produzione e strategie che funzionano.",
    readMore: "Leggi l'articolo",
    back: "Torna alle news",
    loading: "Caricamento…",
    empty: "Nessun articolo disponibile al momento.",
    homeKicker: "News",
    homeTitle: "Dal blog di RV Film",
    homeCta: "Tutte le news",
    source: "Continua su radiovilles.it",
  },
  en: {
    kicker: "News & Blog",
    titleA: "Ideas, strategies",
    titleB: "and new projects.",
    intro: "Articles, press releases and updates from the RV Film world: video marketing, production and strategies that work.",
    readMore: "Read the article",
    back: "Back to news",
    loading: "Loading…",
    empty: "No articles available at the moment.",
    homeKicker: "News",
    homeTitle: "From the RV Film blog",
    homeCta: "All news",
    source: "Continue on radiovilles.it",
  },
};
